'use strict'

module.exports = { version: '8.11.0' }
